/**
 * A shipment a carrier has taken: its parcels, the carrier's parcel ids, the reprint and the
 * cancellation (which asks first: see `cancel-shipment.tsx`).
 */

import { useState } from 'react';
import type { CarrierState } from '@errebi/domain';

import { AnnullaSpedizione } from './cancel-shipment';
import { openLabel } from './label';

export interface PropsSpedizioneBrt {
  readonly ordine: string;
  readonly colli: number;
  readonly vettore: CarrierState;
  readonly inCorso: boolean;
  readonly fai: (percorso: string, corpo?: unknown) => () => void;
}

export function SpedizioneBrt({ ordine, colli, vettore, inCorso, fai }: PropsSpedizioneBrt) {
  const [errore, setErrore] = useState<string | null>(null);
  const etichette = vettore.etichette.filter((e) => !e.annullata);
  const inAnnullamento = vettore.fase === 'annullamento';
  const quanti = colli === 1 ? '1 collo' : `${colli} colli`;

  const ristampa = (barcode: string) => () => {
    setErrore(null);
    openLabel(barcode).catch((e: Error) => setErrore(e.message));
  };

  return (
    <article className="riga riga--ok">
      <div className="riga__cliente">ordine {ordine}</div>
      <div className="riga__sku">
        {vettore.corriere} · {quanti}
        {inAnnullamento && ' · annullamento in corso'}
      </div>
      {etichette.map((e) => (
        <div key={e.collo} className="riga__conto">
          {e.collo} · parcelId {e.parcelId}
          {!inAnnullamento && (
            <button
              className="mod"
              style={{ marginLeft: 8 }}
              aria-label={`Ristampa ${e.collo}`}
              onClick={ristampa(e.collo)}
            >
              Ristampa
            </button>
          )}
        </div>
      ))}
      {errore && (
        <p className="avviso avviso--no" style={{ margin: '8px 0 0' }}>
          {errore}
        </p>
      )}
      {vettore.fase === 'creata' && (
        <AnnullaSpedizione
          ordine={ordine}
          corriere={vettore.corriere}
          colli={colli}
          inCorso={inCorso}
          fai={fai}
        />
      )}
    </article>
  );
}
